/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       AddressFactory.ts
 * @author     Christian Ascone
 * @date       12/27/19 10:01 AM
 */


import faker from 'faker';
import {Address, AddressProviderType} from "@services/src/models";

export class AddressFactory {
    static factoryArray(size: number): Address[] {
        let array = [];
        for (let i = 0; i < size; i++) {
            array.push(AddressFactory.factory());
        }
        return array;
    }

    static factory(): Address {
        return {
            id: faker.random.number(5),
            fullAddress: faker.address.streetAddress(true),
            latitude: +faker.address.latitude(),
            longitude: +faker.address.longitude(),
            placeId: faker.random.alphaNumeric(27),
            placeProvider: AddressProviderType.GoogleMaps,
            street: faker.address.streetName(),
            number: faker.random.number(100) + '',
            city: faker.address.city(),
            locality: faker.address.county(),
            zip: faker.address.zipCode(),
        };
    }
}

